<div class="mi-grid-component">
  <div class="search-and-export-data-panel">
    <label *ngIf="!bottomSearchBar" for="searchId" class="mb-2" translate>{{inputPlaceholder}}</label>
    <input *ngIf="!bottomSearchBar" id="searchId" type="search" class="grid-search-bar top" [(ngModel)]="search"
      (keyup)="onQuickFilterChanged($event)" [placeholder]="inputPlaceholder" />
        <label *ngIf="!bottomSearchBar && search !== ''" (click)="onResetSearchInput()" for="search-bar" [title]="clearSearch"
          class="fa fa-close input-close-icon"></label>
    <div class="export-data-panel">
      <span class="export-button top mr-0" *ngIf="!bottomExportButton && (exportUrl !== '') && totalRecords > 0">
        <button class="header-action-btn export mr-0" (click)="exportGridExcel($event)"
          [attr.aria-label]="'aria_label_download_excel' | translate" title="Download Excel">
          XLS
          <i class="fa fa-fw fa-file-excel-o" aria-hidden="true"></i>
        </button>
      </span>

      <span class="export-button top hidden-link" *ngIf="!bottomExportButton && (printUrl !== '') && totalRecords > 0">
        <button class="header-action-btn export" (click)="exportGridPdf($event)"
          [attr.aria-label]="'aria_label_download_pdf' | translate" title="Download Pdf">
          PDF
          <i class="fa fa-fw fa-file-pdf-o" aria-hidden="true"></i>
        </button>
      </span>
    </div>
  </div>


  <p-table #dt [ngClass]="isDetailScreen ? 'detail-screen-available' : ''" [lazy]="true" [rows]="paginationPageSize"
    [metaKeySelection]="true" [value]="datasource" [paginator]="pagination" [totalRecords]="totalRecords"
    (onLazyLoad)="loadDatasourceLazy($event)" [selectionMode]="rowSelection" (onRowSelect)="onRowSelect($event)"
    (onRowUnselect)="onRowUnselect($event)" [(selection)]="selectedRecords" [resizableColumns]="enableResize"
    [first]="dt.first">

    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of columnDefs; let colId=index;">

          <th *ngIf="col.resize && enableResize" [ngClass]="col?.class ? col.class : ''" pResizableColumn
            [pSortableColumn]="(col?.sort) ? col.sortId: ''" [width]="col?.width" id="th{{colId}}">
             {{col.header}}
            <p-sortIcon aria-hidden="true" *ngIf="col?.sort" [field]="col.sortId"></p-sortIcon>
          </th>

          <th *ngIf="!col.resize" [ngClass]="col?.class ? col.class : ''"
            [pSortableColumn]="(col?.sort) ? col.sortId: ''" >
            {{col.header}}
            <p-sortIcon aria-hidden="true" *ngIf="col?.sort" [field]="col.sortId"></p-sortIcon>
          </th>
        </ng-container>

        <th  class="action-column" *ngIf="actionButtonsDefs.length"
        
          [width]="actionButtonWidth">
          {{ 'label_action' | translate }}
        </th>

      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td  class="grid-align-center" *ngIf="actionButtonsDefs.length === 0"
          [attr.colspan]="columnDefs.length" headers='th0'>
          {{ 'label_no_records_found' | translate }}
        </td>
        <td  class="grid-align-center" *ngIf="actionButtonsDefs.length > 0"
          [attr.colspan]="columnDefs.length + 1" headers='th0'>
          {{ 'label_no_records_found' | translate }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columnDefs" let-rowIndex="rowIndex">
      <!-- Note: [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" were removed from tr below to avoid row selection. -->
      <tr [class]="rowIndex%2==0?'even-row':'odd-row'">
        <td
          *ngFor="let col of columnDefs" [ngClass]="col?.class ? col.class : ''">
          <div class="single-line-comment" title="{{rowData[col.field]}}" style="-webkit-box-orient: vertical;"
            *ngIf="col.cellRendererHtml == undefined" [innerHTML]="rowData[col.field]">
          </div>
          <div class="single-line-comment" style="-webkit-box-orient: vertical;"
            *ngIf="col.cellRendererHtml != undefined && !col.disableInnerHtml"
            [innerHtml]="rowData[col.field].innerHTML | keepHtml">
          </div>
          <div class="single-line-comment" style="-webkit-box-orient: vertical;" onclick="event.stopPropagation();"
            *ngIf="col.cellRendererHtml != undefined && col.disableInnerHtml"
            [innerHtml]="rowData[col.field] | keepHtml">
          </div>
        </td>

        <td class="grid-action-buttons" *ngIf="actionButtonsDefs.length">
          <div class="grid-action">
            <div class="btn-div" *ngFor="let btn of actionButtonsDefs">
              <button class="btn-action" *ngIf="rowData[btn.field]" [attr.aria-label]="rowData[btn.ariaLabel]"
                (click)="actionBtnClick($event, rowData, btn.class)" innerHTML="{{rowData[btn.field]}}">
              </button>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright" let-state>
      Total records: {{state.totalRecords}}
    </ng-template>
  </p-table>
</div>
<!-- Note: Removed to avoid row selection. -->
<!-- <p-sidebar *ngIf="datasource.length > 0" class="grid-sidebar" [(visible)]="displayRowView" position="right">
  <div class="row-heading" translate>label_row_details</div>
  <table>
    <tr *ngFor="let col of columnDefs">
      <td><strong>{{col.header}} <span class="head-colon">:</span></strong></td>
      <td *ngIf="col.cellRendererHtml == undefined"><span innerHTML="{{datasource[rowSelectIndex][col.field]}}"></span>
      </td>
      <td *ngIf="col.cellRendererHtml != undefined"><span
          innerHTML="{{datasource[rowSelectIndex][col.field].innerHTML}}"></span></td>
    </tr>
  </table>
  <div class="grid-action-buttons" *ngIf="actionButtonsDefs.length">
    <div class="grid-action">
      <span *ngFor="let btn of actionButtonsDefs">
        <button *ngIf="datasource[rowSelectIndex][btn?.title]" class="sidebar-button positive-button" [icon]="datasource[rowSelectIndex][btn?.title]?.icon"
          [ngClass]="datasource[rowSelectIndex][btn?.title]?.btnClass ? datasource[rowSelectIndex][btn?.title]?.btnClass : ''"
          pButton (click)="actionBtnClick($event, datasource[rowSelectIndex], btn?.class)"
          [label]="datasource[rowSelectIndex][btn?.title]?.title"></button>
      </span>
    </div>
  </div>

</p-sidebar> -->